import { graphql } from '../../gql';

export const QUERY_SENTIMENT_V3 = graphql(`
  query QuerySentimentV3($req: SentimentV3Req) {
    sentiment_v3(req: $req) {
      entities {
        id
        index
        short_name
        long_name
        metrics {
          overall {
            month_id
            value
            weight
            count
          }
          business_outlook {
            month_id
            value
            weight
            count
          }
          career_growth {
            month_id
            value
            weight
            count
          }
          compensation {
            month_id
            value
            weight
            count
          }
          benefits {
            month_id
            value
            weight
            count
          }
          healthcare {
            month_id
            value
            weight
            count
          }
          retirement_pension {
            month_id
            value
            weight
            count
          }
          childcare {
            month_id
            value
            weight
            count
          }
          education_assistance {
            month_id
            value
            weight
            count
          }
          wellness_programs {
            month_id
            value
            weight
            count
          }
          work_life_balance {
            month_id
            value
            weight
            count
          }
          diversity_and_inclusion {
            month_id
            value
            weight
            count
          }
          leadership {
            month_id
            value
            weight
            count
          }
          culture {
            month_id
            value
            weight
            count
          }
          remote_work {
            month_id
            value
            weight
            count
          }
          onboarding {
            month_id
            value
            weight
            count
          }
          mentorship {
            month_id
            value
            weight
            count
          }
          technology {
            month_id
            value
            weight
            count
          }
          promotion_opportunities {
            month_id
            value
            weight
            count
          }
          paid_time_off {
            month_id
            value
            weight
            count
          }
          transparency {
            month_id
            value
            weight
            count
          }
          efficiency_and_bureaucracy {
            month_id
            value
            weight
            count
          }
          product_and_service_quality {
            month_id
            value
            weight
            count
          }
          prestige {
            month_id
            value
            weight
            count
          }
          coworkers {
            month_id
            value
            weight
            count
          }
          mission_and_vision {
            month_id
            value
            weight
            count
          }
          workplace_facilities {
            month_id
            value
            weight
            count
          }
          training {
            month_id
            value
            weight
            count
          }
          clients_and_customers {
            month_id
            value
            weight
            count
          }
          company_growth {
            month_id
            value
            weight
            count
          }
          schedule_flexibility {
            month_id
            value
            weight
            count
          }
          job_security {
            month_id
            value
            weight
            count
          }
          overtime {
            month_id
            value
            weight
            count
          }
          family_support {
            month_id
            value
            weight
            count
          }
          commission {
            month_id
            value
            weight
            count
          }
          independence {
            month_id
            value
            weight
            count
          }
          commute {
            month_id
            value
            weight
            count
          }
          safety {
            month_id
            value
            weight
            count
          }
          internal_communication {
            month_id
            value
            weight
            count
          }
          office_politics {
            month_id
            value
            weight
            count
          }
          harassment {
            month_id
            value
            weight
            count
          }
          honesty {
            month_id
            value
            weight
            count
          }
          ethics {
            month_id
            value
            weight
            count
          }
          commitment {
            month_id
            value
            weight
            count
          }
          compliance {
            month_id
            value
            weight
            count
          }
          integrity {
            month_id
            value
            weight
            count
          }
        }
      }
    }
  }
`);
